export default "__VITE_ASSET__e789d888__"